import { doTagNationalityOnChange } from '../../../sections/PersonalData/tagging';
import { validateDocNumber } from '../../../validations/docNumber';
import {
    getReferenceCodeByCountry,
    getSecondaryDocumentTypeByCountry,
    isCountrySpain,
} from 'utilities/multiLanguageHelper';
import { COUNTRY_CODE_ES, COUNTRY_DOCUMENT_TYPE_DNI, COUNTRY_DOCUMENT_TYPE_NIE } from 'constants/multiLanguage';

export const useNationalityOnChange = ({ userProfile, formActions }) => {
    const { docNumber } = userProfile;

    const handleChangeNationality = value => {
        doTagNationalityOnChange();
        const loweredValue = value.toLowerCase();

        const docNumberValidation = documentType => {
            docNumber &&
                formActions.setValidity('userProfile.docNumber', {
                    valid: validateDocNumber({ docNumber, documentType }),
                });
        };

        if (isCountrySpain()) {
            const newDocumentType =
                loweredValue === COUNTRY_CODE_ES ? COUNTRY_DOCUMENT_TYPE_DNI : COUNTRY_DOCUMENT_TYPE_NIE;
            formActions.change('userProfile.documentType', newDocumentType);
            docNumberValidation(newDocumentType);

            return;
        }

        const actualCountry = getReferenceCodeByCountry();
        const secondaryDocument = getSecondaryDocumentTypeByCountry();
        actualCountry !== loweredValue && formActions.change('userProfile.documentType', secondaryDocument);
        docNumberValidation(secondaryDocument);
    };

    return { handleChangeNationality };
};
